import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreNumber } from '../../ParseHelper';

const starChestLevelKey = 'v1_44_0_starChestLevel' as const;

type PlayerStateKey = 'starChestLevel';
type PlayerDataKeys = typeof starChestLevelKey;
export default class StarChestLevel implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            playerEndpointData[starChestLevelKey] !==
            playerStateData.starChestLevel
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return restoreNumber(playerEndpointData[starChestLevelKey], null);
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            [starChestLevelKey]: playerStateData.starChestLevel,
        };
    }
}
